<template>
  <div class="dashboard-container">
    <div class="app-container">
      <el-card shadow="never">
        <el-form :inline="true" class="demo-form-inline">
          <div class="cg">
            <el-form-item label="菜单名称：">
              <el-input v-model="listQuery.searchMenu" style="width: 200px" placeholder="请输入菜单名称"
                        clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="btnMuen" size="small" class="btns" icon="el-icon-plus">添加菜单</el-button>
            </el-form-item>
          </div>
        </el-form>
        <el-table
          :header-cell-style="{ height: '40px' ,fontSize:'18px',color:'black',fontweight:400,background: '#fafafa'}"
          :header-row-style="{text: 'center'}"
          v-loading="listLoading"
          :default-expand-all="false"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          :data="tableData"
          border style="width: 100%;margin-top: 50px;"
          row-key="jurId"
          :highlight-current-row="true"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column prop="jurTitle" label="菜单" align="left"  width="180">
            <template slot-scope="scope">
              {{scope.row.jurTitle}}
              <span class="add_btn" @click="addRouter(scope.row)">+</span>
            </template>
          </el-table-column>
          <el-table-column
            label="图标"
            align="center"
            width="80">
            <template slot-scope="scope">
              <i :class="scope.row.jurIcon"></i>
            </template>
          </el-table-column>
          <el-table-column
            prop="jurUrl"
            header-align="center"
            align="left"
            label="路由地址">
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="updateTime"
            align="center"
            label="修改时间">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="deleteById( scope.row)" class="btns" icon="el-icon-close">删除</el-button>
            </template>
          </el-table-column>
          <h2>3123213</h2>
<!--          <el-table-column label="操作" width="180px" header-align="center">-->
<!--              <template slot-scope="scope">-->
<!--                <el-button type="text" icon="el-icon-edit">编辑</el-button>-->
<!--                <el-button type="text" icon="el-icon-delete" :disabled="scope.row.children.length > 0">删除</el-button>-->
<!--              </template>-->
<!--          </el-table-column>-->
        </el-table>
      </el-card>

      <el-dialog
        title="添加路由"
        :visible.sync="addRoleShow"
        width="30%">
        <el-form :model="roleFrom" status-icon :rules="rules" ref="roleFrom" label-width="100px" class="demo-roleFrom">
          <el-form-item label="父级标题" style="text-align: left;" v-if="classAmenu">
            <span style="margin-left:10px">{{roleList.jurTitle}}</span>
          </el-form-item>
          <el-form-item label="创建标题" prop="jurTitle">
            <el-input v-model="roleFrom.jurTitle"></el-input>
          </el-form-item>
          <el-form-item label="菜单路由" prop="jurUrl" v-if="classAmenu">
            <el-input v-model="roleFrom.jurUrl"></el-input>
          </el-form-item>
          <el-form-item label="菜单图标" prop="jurIcon">
            <el-input v-model="roleFrom.jurIcon"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addRoleShow = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('roleFrom')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import apiBaseUrl from '../../../config/api';
import { addJurisdiction , deleteJurisdiction } from "@/api/salaryapi"
export default {
  data() {
    return {
      listQuery: {
        po_id: 0,
        searchMenu: '',
      },
      listLoading: false, //加载样式
      tableData: [],
      roleFrom:{
        jurTitle:"",
        jurUrl:"",
        jurIcon:"",
      },
      roleList:{},
      addRoleShow:false,
      classAmenu:true,
      rules:{
        jurTitle: [
            { required: true, message: '请输入创建标题', trigger: 'blur' },
            { min: 1, max: 55, message: '长度在 1 到 20个字符', trigger: 'blur' }
        ],
        jurUrl: [
          { required: true, message: '请输入路由', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100个字符', trigger: 'blur' }
        ],
      },
    }
  },
  created() {
    this.listData()
  },
  mounted() {
  },
  methods: {
    deleteById(row){
      console.log(row);
      if (row.children.length > 0) {
        this.$confirm('请先删除该文件下的子集路由？',"提示",{
          confirmButtonText:"确定",
          // showConfirmButton:false,
          // cancelButtonText:"取消",
          showCancelButton:false,
          type:"warning"
        })
        return
      }
      this.$confirm('确认删除该路由？',"提示",{
        confirmButtonText:"确定",
        cancelButtonText:"取消",
        type:"warning"
      }).then(()=>{
        deleteJurisdiction(row.jurId).then((res)=>{
          if (res.code == 200) {
            this.listData()
            this.$message.success("删除成功")
          }else{
            this.$message.erroe(res.message)
          }
        })
      })
    },
    btnMuen(){
      this.classAmenu = false
      this.openDiakang()
    },
    submitForm(roleFrom){
      this.$refs[roleFrom].validate((valid)=>{
        if (valid) {
          let params = {
            jurIcon:this.roleFrom.jurIcon,
            jurTitle:this.roleFrom.jurTitle,
            jurUrl:this.roleFrom.jurUrl,
            jurType:"menu"
          }
          if (this.classAmenu) {  // 一级菜单一下
            params.jurParent = this.roleList.jurId
          }else{ // 添加根目录
            params.jurParent = 0
          }
          console.log(params);

          addJurisdiction(params).then((res)=>{
            console.log(res);
            if (res.code) {
              this.addRoleShow = false
              this.$message.success("添加成功")
              this.listData()
            }else{
              this.$message.error(res.message)
            }
          })
        }else{
           console.log("asdf");
        }
      })
    },
    addRouter(row){
       this.roleList = row
       this.classAmenu = true
       this.openDiakang()
    },
    openDiakang(){
      this.roleFrom = {
        jurTitle:"",
        jurUrl:"",
        jurIcon:"",
      },
      this.addRoleShow = true
    },
    //查询所有权限
    listData() {
      this.listLoading = true
      const data = {
        po_id: this.listQuery.po_id,
        jur_title: this.listQuery.searchMenu
      }
      axios
        .post(
          `${apiBaseUrl}/admin/jurisdictionlist`,
          data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
        )
        .then(response => {
          this.tableData = response.data.data.list;
        })
        .catch(error => {
          console.log(error);
        }).finally(() => {
        this.listLoading = false
      });
    },
    handleSearch() {
      this.listData()
    }
  },
}

</script>
<style scoped>
.demo-form-inline {
  height: 35px;
  display: flex;
}

.cg {
  /* flex: 1; */
  margin-top: 20px;
}
.add_btn{
  display: inline-block;
  font-size: 30px;
  vertical-align: middle;
  position: absolute;
  right: 10px;
  cursor: pointer;

}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/AuthManagement.vue